<script>
  import Tooltip from '@components/general/tooltip.svelte'
  import { cn } from '@lib/utils'
  let { value = $bindable(""), options = [], prefix, name, hint, disabled = false, segmentClass = "", onSelect, iconProps = {}, containerClass = "", ...containerProps } = $props()
  let index = $state(options.findIndex(opt => opt.value === value) || 0)
  let container = $state(null)

  function handleKeydown(e) {
    if (disabled) return
    if (["ArrowUp", "ArrowLeft"].includes(e.key)) {
      e.preventDefault()
      index = Math.max(0, index - 1)
      value = options[index].value
    } else if (["ArrowDown", "ArrowRight"].includes(e.key)) {
      e.preventDefault()
      index = Math.min(options.length - 1, index + 1)
      value = options[index].value
    } else if (e.key === "Enter") {
      e.preventDefault()
      onSelect?.(options[index].value)
    }
  }
</script>

<!-- svelte-ignore a11y_no_noninteractive_tabindex -->
 <Tooltip {hint}>
  <div bind:this={container} class={cn("boolean-container", containerClass)} class:disabled tabindex="0" role="radiogroup" {...containerProps}
    onkeydown={handleKeydown}
    onpointerdown={() => container?.focus()}>

    {#if prefix}
      <span class="text-gray-700 text-xs p-2 pr-3 h-full leading-[1]">{prefix}</span>
    {/if}
    
    {#each options as option (option.value)}
      {@const selected = option.value === value}
      <Tooltip hint={option.hint}>
        <label class={cn("boolean-segment h-full", segmentClass)} class:selected>
          <input type="radio" {name} value={option.value} bind:group={value} disabled={disabled} onclick={() => onSelect?.(option.value)} />
          {#if option.Icon}
            <option.Icon size={14} class={cn("text-gray-400", selected ? "text-gray-700" : "")} strokeWidth={1.5} {...iconProps} />
          {:else}
            {option.label}
          {/if}
        </label>
      </Tooltip>
    {/each}
  </div>
</Tooltip>

<style>
  .disabled {
    opacity: 0.8;
    /* pointer-events: none; */
    cursor: not-allowed;
  }

  .boolean-container:focus-visible {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
  }
</style>